<template>
  <span>
    第
    <input type="text" :class="cls" @focus="focus" @blur="refresh" ref="window"
	   v-model="field" @keyup="keyUp"/>
    {{eqn ? '式' : op.rcTxt}}
  </span>
</template>

<script>
import { Operation } from '@/lib/base.js';

export default {
  name: 'InputNum',
  props: {
    op: Operation,
    prop: String,
    size: Number,
    eqn: {type:Boolean, defalut: false}
  },
  data: function(){
    return {
      field: '' + (this.op[this.prop] +1)
    }
  },
  methods: {
    focus(){
      this.op.type = this.action;
    },
    refresh(){
      this.field = '' + (this.op[this.prop] +1);
    },
    keyUp(event){
      if(! '0123456789'.includes(event.key)){
	this.$parent.keyUp(event);
      }
    }
  },
  computed: {
    action(){
      return this.prop.split('_')[0];
    },
    cls(){
      const ar = [];
      if(this.action == this.op.type){
	if(this.prop == 'add_i1'){
	  ar.push('s3');
	}else if(this.action == 'swap'){
	  ar.push('s2');
	}else{
	  ar.push('s1');
	}
      }
      if(this.op[this.prop] < 0 || this.op[this.prop] >= this.size){
	ar.push('error');
      }
      return(ar.join(' '));
    }
  },
  watch: {
    field: function(to,from){
      if(to.match(/^[0-9]*$/)){
  	this.$set(this.op,this.prop,Number(to)-1);
      }else{
  	this.field = from;
      }
    },
    op: function(){
      this.refresh();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input {
    width: 25px;
    height:21px;
    border: solid 4px #888;
}
.s1 {
    border-color: #f88 !important;
}
.s2 {
    border-color: #8f8 !important;
}
.s3 {
    border-color: #88f !important;
}
</style>
